module.exports = __webpack_public_path__ + "img/FR16298.0b3a82df.png";